import { Button } from 'ui/atoms/Button/Button';
import { Image } from 'ui/atoms/Image';
import { TitleBlock } from 'ui/atoms/TitleBlock/TitleBlock';
import { OurCustomersV2 } from 'ui/molecules/OurCustomers/OurCustomersV2';

import styles from './PricingClients.module.scss';

import { CLIENT_QUOTES } from './PricingClients.data';

interface Props {
  ctaHref?: string;
}

export const PricingClients = ({ ctaHref = '#data' }: Props) => (
  <section className={styles.section}>
    <div className={styles.container}>
      <div className={styles.intro}>
        <TitleBlock
          align="left"
          theme="dark"
          title="Our clients"
          description="Over 1,000 satisfied customers rely on Global Database for essential credit risk insights, using our detailed, real-time financial data for accurate and effective business decisions."
          className={styles.introText}
        />

        <Button type="white-outline" size="lg" href={ctaHref}>
          Join in today
        </Button>
      </div>

      <OurCustomersV2 hasBackground={false} scrollerBackgroundColor="transparent" className={styles.logos} />

      <div className={styles.cards}>
        {CLIENT_QUOTES.map((item) => (
          <figure className={styles.card} key={item.brand}>
            <span className={styles.quoteMark} aria-hidden="true">
              &ldquo;
            </span>

            <blockquote className={styles.quote}>{item.quote}</blockquote>

            <figcaption className={styles.brand}>
              {item.logo ? (
                <Image width={96} height={28} src={item.logo} alt={`${item.brand} logo`} className={styles.brandLogo} />
              ) : (
                <>
                  <span className={styles.brandDot} aria-hidden="true" />
                  {item.brand}
                </>
              )}
            </figcaption>
          </figure>
        ))}
      </div>
    </div>
  </section>
);
